import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

import AboutMe from '@/views/AboutMe.vue';
import Bookshelf from '@/views/Bookshelf.vue';
import MyPublish from '@/views/MyPublish.vue';
import Project from '@/views/Project.vue';
import TimeTable from '@/views/TimeTable.vue';
import Awards from '@/views/Awards.vue';
import Patent from '@/views/Patent.vue';
import Membership from '@/views/Membership.vue';
import Tasks from '@/views/Tasks.vue';

Vue.use(VueRouter)

	const routes: Array<RouteConfig> = [
		{
			path: '/',
			name: 'AboutMe',
			component: AboutMe,
		},

		{
			path: '/Kitaplik',
			name: 'Bookshelf',
			component: Bookshelf,
		},

		{
			path: '/Yayinlar',
			name: 'MyPublish',
			component: MyPublish,
		},

		{
			path: '/Projeler',
			name: 'Project',
			component: Project,
		},

		{
			path: '/Ders-Programi',
			name: 'TimeTable',
			component: TimeTable,
		},

		{
			path: '/Oduller',
			name: 'Awards',
			component: Awards,
		},

		{
			path: '/Patentler',
			name: 'Patent',
			component: Patent,
		},

		{
			path: '/Uyelikler',
			name: 'Membership',
			component: Membership,
		},

		{
			path: '/Gorevler',
			name: 'Tasks',
			component: Tasks,
		},
		
		{
			path: '/*',
			redirect: '/',
		}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
